/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-22 08:46:15
 * @ Modified by: David Helmick
 * @ Modified time: 2024-06-07 11:18:43
 * @ Description: Card to review and change billing plan
 */

import React, { useState } from 'react'
// Centralized lodash imports - much cleaner!
import {
  map,
  split,
  upperFirst,
  round,
  isEmpty,
  replace,
} from '@/utils/lodash'
import {
  AppBar,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Dialog,
  Grid,
  Slide,
  Toolbar,
  Typography,
  Box,
} from '@mui/material'
import withSession from '@/housefolios-components/Session/withSession'
import { useMutation } from '@apollo/client/react'
import { CREATE_SESSION } from '@/housefolios-components/LaunchpadComponents/mutations'
import SubscriptionPlanCard from './SubscriptionPlanCard'
import { currencyFormat } from '@/utils/number'
import { btnOutlinePrimaryTabSx } from '@/theme/skinSx'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

function SaveMoneyComponent(props) {
  const [createBillingPortalSession] = useMutation(CREATE_SESSION)

  const [showPlans, setShowPlans] = useState(false)
  const handleOpenShowPlans = () => {
    setShowPlans(true)
    // if (props.closeParent)
    //   props.closeParent()
  }
  const handleCloseShowPlans = () => {
    setShowPlans(false)
  }

  const [plan, billing] = props.session.me.subscriptionPlan
    ? split(replace(props.session.me.subscriptionPlan, '_', '-'), '-')
    : ''

  const [activeTab, setActiveTab] = useState(
    billing === 'yearly' ? 'checkedB' : 'checkedC',
  )

  function tabSwitch(tab) {
    if (activeTab !== tab) setActiveTab(tab)
  }

  async function changePlan() {
    var session = await createBillingPortalSession()

    window.open(
      session.data.createBillingPortalSession.url,
      '_self',
      '',
    )
  }

  const pricingPlans = props.session.me.activeOrg.currentlyFree
    ? [
        {
          nameMonthly: 'free-monthly',
          nameYearly: 'free-yearly',
          label: 'Free',
          subHeaderMonthly: '',
          subHeaderYearly: '',
          search: '*Nationwide property search',
          analyze: '*Analyze off-market properties',
          comp: '*Sold comp data',
        },
        {
          nameMonthly: 'investor-monthly',
          nameYearly: 'investor-yearly',
          label: 'Investor',
          subHeaderMonthly: 'Monthly Plan',
          subHeaderYearly: 'Annual Plan',
          search: 'Nationwide property search',
          analyze: 'Analyze off-market properties',
          comp: 'Sold comp data',
        },
        {
          nameMonthly: 'growth-monthly',
          nameYearly: 'growth-yearly',
          label: 'Growth',
          subHeaderMonthly: 'Monthly Plan',
          subHeaderYearly: 'Annual Plan',
          search: 'Nationwide property search',
          analyze: 'Analyze off-market properties',
          comp: 'Sold comp data',
          //housefoliosMarketplace: 'List on Housefolios marketplace',
        },
        {
          nameMonthly: 'pro-monthly',
          nameYearly: 'pro-yearly',
          label: 'Pro',
          subHeaderMonthly: 'Monthly Plan',
          subHeaderYearly: 'Annual Plan',
          search: 'Nationwide property search',
          analyze: 'Analyze off-market properties',
          comp: 'Sold comp data',
          //housefoliosMarketplace: 'List on Housefolios marketplace',
        },
      ]
    : [
        {
          nameMonthly: 'investor-monthly',
          nameYearly: 'investor-yearly',
          label: 'Investor',
          subHeaderMonthly: 'Monthly Plan',
          subHeaderYearly: 'Annual Plan',
          search: 'Nationwide property search',
          analyze: 'Analyze off-market properties',
          comp: 'Sold comp data',
        },
        {
          nameMonthly: 'growth-monthly',
          nameYearly: 'growth-yearly',
          label: 'Growth',
          subHeaderMonthly: 'Monthly Plan',
          subHeaderYearly: 'Annual Plan',
          search: 'Nationwide property search',
          analyze: 'Analyze off-market properties',
          comp: 'Sold comp data',
          //housefoliosMarketplace: 'List on Housefolios marketplace',
        },
        {
          nameMonthly: 'pro-monthly',
          nameYearly: 'pro-yearly',
          label: 'Pro',
          subHeaderMonthly: 'Monthly Plan',
          subHeaderYearly: 'Annual Plan',
          search: 'Nationwide property search',
          analyze: 'Analyze off-market properties',
          comp: 'Sold comp data',
          //housefoliosMarketplace: 'List on Housefolios marketplace',
        },
      ]

  const date = !isEmpty(props.session.me.activeOrg.subscriptions)
    ? props.session.me.activeOrg.subscriptions[0].current_period_end
      ? new Date(
          props.session.me.activeOrg.subscriptions[0]
            .current_period_end * 1000,
        )
      : new Date('01/01/1970')
    : props.session.me.activeOrg.parentCorp &&
        !isEmpty(props.session.me.activeOrg.parentCorp.subscriptions)
      ? props.session.me.activeOrg.parentCorp.subscriptions[0]
          .current_period_end
        ? new Date(
            props.session.me.activeOrg.parentCorp.subscriptions[0]
              .current_period_end * 1000,
          )
        : new Date('01/01/1970')
      : props?.session?.me?.activeOrg?.memberProvidedSubscriptions &&
          !isEmpty(
            props?.session?.me?.activeOrg
              ?.memberProvidedSubscriptions,
          )
        ? new Date(
            props?.session?.me?.activeOrg
              ?.memberProvidedSubscriptions[0].current_period_end *
              1000,
          )
        : new Date('01/01/1970')
  const dateString = `${
    date.getMonth() + 1
  }/${date.getDate()}/${date.getFullYear()}`
  const noSub = dateString === '1/1/1970' ? true : false
  const disabled = !isEmpty(props.session.me.activeOrg.subscriptions)
    ? props.session.me.activeOrg.subscriptions[0].cancel_at_period_end
    : props.session.me.activeOrg.parentCorp &&
        !isEmpty(props.session.me.activeOrg.parentCorp.subscriptions)
      ? props.session.me.activeOrg.parentCorp.subscriptions[0]
          .cancel_at_period_end
      : true
  const isCoached = props.session.me.subscriptionPlan
    ? props.session.me.subscriptionPlan === 'group-coaching' ||
      props.session.me.subscriptionPlan === 'personalized-coaching'
      ? true
      : false
    : false
  return (
    <>
      <Card variant="outlined" style={{ backgroundColor: '#253152', position: 'relative' }} sx={[{ width: '100%', display: 'flex', flexDirection: 'column', flexGrow: 1, justifyContent: 'center', alignItems: 'center', textAlign: 'center', p: '1.5rem', color: '#fff !important', '& h5, & span, & li, & b, & .opacity-8, & .opacity-6, & .font-size-lg, & .display-2, & .display-5': { color: '#fff', }, }, { boxShadow: "0 0.18rem 0.3rem rgba(166, 166, 185, 0.5), 0 0.326rem 3rem rgba(79, 80, 98, 0.3) !important" }]}>
        <Box component="span" sx={{
          position: "absolute",
          zIndex: 8,
          width: 160,
          height: 160,
          overflow: "hidden",
          "& > small": {
            position: "absolute",
            display: "block",
            width: "100%",
            padding: "0.25rem",
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: "bold",
            fontSize: "0.769rem",
            transform: "rotate(45deg)",
            boxShadow: "0 3px 6px -3px rgba(7, 9, 25, 0.5)",
            top: 27,
            left: 37,
            color: "#fff",
            backgroundColor: "#368cff",
          },
          top: 0,
          right: 0,
        }}>
          <small>Selected</small>
        </Box>
        <Box
          component="h5"
          sx={{ fontWeight: 700, mb: '1.5rem', color: '#fff' }}
        >
          {plan ? upperFirst(plan) : 'Special'} Plan
        </Box>
        <Box sx={[{ mb: '1.5rem' }, { background: "rgba(255, 255, 255, 0.1) !important" }, { background: "#eeeff8", height: "1px", overflow: "hidden" }]} />
        <div>
          <Box sx={{ mb: '0.5rem', color: '#fff' }}>
            <Box component="span" sx={[{ fontWeight: 700, color: '#fff' }, { fontSize: "3rem", fontWeight: "300", lineHeight: "1.2" }]}>
              {isCoached
                ? '$149'
                : currencyFormat.format(
                    round(props.session.me.subscriptionPrice / 100),
                  )}
            </Box>
            <Box component="span" sx={{ opacity: "0.8 !important" }}>
              /{' '}
              {isCoached
                ? 'month'
                : props.session.me.subscriptionPlan ===
                    'enterprise-affiliate'
                  ? 'monthly'
                  : billing === 'monthly'
                    ? 'month'
                    : 'year'}
            </Box>
          </Box>
          {!props.session.me.activeOrg.currentlyFree && !noSub && (
            <Box component="ul" sx={[{ mb: '1.5rem' }, [{ opacity: "0.6 !important" }, { listStyle: "none", pl: 0 }]]}>
              <li>
                {disabled
                  ? 'Plan will be canceled on: '
                  : 'Next billing period '}{' '}
                <b style={{ color: 'white' }}>{dateString}</b>
              </li>
            </Box>
          )}
        </div>
        <Box sx={[{ mb: '1.5rem' }, { background: "rgba(255, 255, 255, 0.1) !important" }, { background: "#eeeff8", height: "1px", overflow: "hidden" }]} />
        {billing === 'monthly' && !disabled && (
          <>
            <Box sx={[{ mb: '1rem', fontWeight: 700, color: '#fff' }, { fontSize: "1.15rem !important" }]}>
              {/* Switch to annual billing & save 20% */}
              Save 20% with annual billing
            </Box>
          </>
        )}

        {props?.session?.me?.activeOrg?.member === 'RWN' && (
          <Button onClick={ isEmpty(props.session.me.activeOrg.subscriptions) ? props.toggleSubscribe : changePlan } fullWidth sx={[{
            boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
            color: "#fff",
            backgroundColor: "#368cff",
            backgroundImage: "none",
            borderColor: "#368cff",
            "&:not(:disabled):hover": { backgroundColor: "#368cff", color: "#fff" },
            "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#036fff" },
            "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(54, 140, 255, 0.4), 0 0.0625rem 0.385rem rgba(54, 140, 255, 0.54)" },
            "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
            "html[data-color-mode=\"dark\"] &": { color: "#fff !important" },
          }, { fontWeight: 700, textTransform: 'uppercase', display: 'inline-block', }, { boxShadow: "0 0.313rem 0.8rem rgba(7, 9, 25, 0.3), 0 0.126rem 0.225rem rgba(7, 9, 25, 0.1) !important", fontSize: "0.875rem !important" }]}>
            Manage Plan
          </Button>
        )}
        {props?.session?.me?.activeOrg?.member !== 'RWN' &&
          !isCoached && (
            <Button fullWidth onClick={handleOpenShowPlans} target="_blank" sx={[{
              boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
              color: "#fff",
              backgroundColor: "#368cff",
              backgroundImage: "none",
              borderColor: "#368cff",
              "&:not(:disabled):hover": { backgroundColor: "#368cff", color: "#fff" },
              "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#036fff" },
              "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(54, 140, 255, 0.4), 0 0.0625rem 0.385rem rgba(54, 140, 255, 0.54)" },
              "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
              "html[data-color-mode=\"dark\"] &": { color: "#fff !important" },
            }, { fontWeight: 700, textTransform: 'uppercase', display: 'inline-block', }, { boxShadow: "0 0.313rem 0.8rem rgba(7, 9, 25, 0.3), 0 0.126rem 0.225rem rgba(7, 9, 25, 0.1) !important", fontSize: "0.875rem !important" }]}>
              {billing === 'yearly'
                ? 'Compare Plans'
                : 'Get more by upgrading'}
            </Button>
          )}
      </Card>
      <Dialog
        fullScreen
        open={showPlans}
        onClose={handleCloseShowPlans}
        slots={{
          transition: Transition,
        }}
      >
        <AppBar enableColorOnDark sx={{ position: 'fixed' }}>
          <Toolbar>
            <Typography
              variant="h6"
              sx={{ ml: 3, color: 'white', flex: 1 }}
            >
              Subscription Plans
            </Typography>
            <Button
              variant="outlined"
              margin="dense"
              style={{ color: 'white', borderColor: 'white' }}
              onClick={handleCloseShowPlans}
            >
              Cancel
            </Button>
          </Toolbar>
        </AppBar>
        <Grid
          container
          direction="row"
          style={{
            // padding: 100,
            paddingTop: 100,
            paddingLeft: 50,
            paddingRight: 50,
            paddingBottom: 25,
          }}
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Grid size={12} style={{ textAlign: 'center' }}>
            <Typography variant="h5" color="textPrimary">
              Save 20% with annual billing{' '}
            </Typography>
          </Grid>
          <Grid
            size={12}
            style={{
              textAlign: 'center',
              marginTop: 5,
              marginBottom: 20,
            }}
          >
            <ButtonGroup size="small" variant="text">
              <Button
                onClick={() => {
                  tabSwitch('checkedC')
                }}
                sx={btnOutlinePrimaryTabSx(activeTab === 'checkedC')}
              >
                Monthly
              </Button>
              <Button
                onClick={() => {
                  tabSwitch('checkedB')
                }}
                sx={btnOutlinePrimaryTabSx(activeTab === 'checkedB')}
              >
                Annual
              </Button>
            </ButtonGroup>
          </Grid>
          {map(pricingPlans, (section) => (
            <SubscriptionPlanCard
              key={section.id} // Assuming each section has a unique ID
              activeTab={activeTab}
              section={section}
              session={props?.session}
              toggleSubscribe={props?.toggleSubscribe}
              changePlan={changePlan}
            />
          ))}
        </Grid>
        {props.session.me.activeOrg.currentlyFree && (
          <Grid
            size={12}
            style={{
              position: 'absolute',
              bottom: '50px',
              left: '50px',
            }}
          >
            <Typography style={{ fontSize: 12 }}>
              * Included in the free account you have the ability to
              analyze 5 properties. The only way to be able to add
              additional properties is by earning them through our
              bonus property program.
            </Typography>
          </Grid>
        )}
      </Dialog>
    </>
  )
}

export default withSession(SaveMoneyComponent)
